var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-chart-1"},[_c('div',[_c('div',{staticClass:"rc1-header"},[_vm._v("总计运单数")]),_c('div',{staticClass:"rc1-chart-container"},[_c('div',{staticClass:"cc-details"},_vm._l((String(_vm.businessTotal)),function(item,index){return _c('div',{key:index,staticClass:"card"},[_vm._v(_vm._s(item))])}),0)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }